import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function LayerHollywood() {
  return <section className="py-24 bg-gradient-to-b from-slate-950 to-slate-900" data-id="element-41">
      <div className="max-w-7xl mx-auto px-6" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-43">
          <div className="flex items-center gap-3 mb-4" data-id="element-44">
            <div className="bg-red-600 text-white px-4 py-1 rounded-full text-sm font-semibold" data-id="element-45">
              LAYER 1
            </div>
            <Sparkles className="w-5 h-5 text-red-600" data-id="element-46" />
          </div>
          <h2 className="font-editorial text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-47">
            The Master-class Intro
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl" data-id="element-48">
            A cinematic teaser introducing the 6 KEEs like a Netflix
            master-class — building anticipation, credibility, and speaker
            recognition from the first frame.
          </p>
        </motion.div>

        {/* Actual presentation slide */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="relative rounded-2xl overflow-hidden shadow-2xl ring-1 ring-white/10 bg-[#2d4a35]" data-id="element-49">
          <img src="https://cdn.magicpatterns.com/uploads/rLDc9we1KTPB3jN935ix8N/Screenshot_2026-05-07_at_1.13.58_PM.png" alt="Introducing your speakers — Dr. Stephan Weidinger: Dosing flexibility with tralokinumab" className="w-full h-auto block" data-id="element-50" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-center text-slate-400 mt-12 italic" data-id="element-51">
          "Oh, it's Dr. Weidinger — he's brilliant on tralokinumab dosing"
        </motion.p>
      </div>
    </section>;
}